import { makeAutoObservable, runInAction } from 'mobx'
import CasesService from '../../services/CasesService'
import { CASES_PREFIX } from '../../routing/paths'
import constants from '../../util/constants'

class ScanSearchStore {
  constructor () {
    this.isLoading = false
    this.qrFound = false
    this.error = ''

    makeAutoObservable(this)

    this.casesService = new CasesService()
  }

  clearErrors () {
    this.error = ''
  }

  setErrors (error) {
    this.error = error
  }

  async search (result) {
    if (!this.qrFound && !this.isLoading) {
      this.isLoading = true

      let url = null
      try {
        url = new URL(result)
      } catch (error) {
        this.isLoading = false
        this.error = 'The QR Code is invalid'
        return false
      }

      const pathname = url.pathname
      const slug = pathname.replace(`${CASES_PREFIX}/`, '')

      try {
        const immobilizationCase = await this.casesService.loadBySlug(
          slug,
          constants.releaseMethodCodes.Manual
        )

        runInAction(() => {
          this.isLoading = false
          this.qrFound = true
        })

        return immobilizationCase
      } catch (e) {
        runInAction(() => {
          this.isLoading = false
          this.error = 'The QR Code is invalid'
        })
        return false
      }
    }

    return false
  }
}

export default ScanSearchStore
